"use client";

import { Box, Collapse, colors } from "@mui/material";
import RenderQuillContent from "@v2/components/RenderQuillContent";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";

type DescriptionContent = { content: string } | null;

const COLLAPSED_HEIGHT = 180;

export default function Description({ content }: { content: DescriptionContent }) {
    const [expanded, setExpanded] = useState(false);

    if (!content?.content) return null;

    return (
        <Box sx={{ px: { xs: 3, lg2: 0 }, maxWidth: 900 }}>
            <Box sx={{ position: 'relative' }}>
                <Collapse in={expanded} collapsedSize={COLLAPSED_HEIGHT}>
                    <RenderQuillContent html={content.content} />
                </Collapse>
                {!expanded && (
                    <Box sx={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        height: 80,
                        background: 'linear-gradient(to bottom, transparent, #fff)',
                        pointerEvents: 'none',
                    }} />
                )}
            </Box>
            <Box
                component="span"
                onClick={() => setExpanded(s => !s)}
                sx={{
                    mt: 1.5,
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '4px',
                    color: colors.red[800],
                    fontSize: 12,
                    fontWeight: 500,
                    cursor: 'pointer',
                    userSelect: 'none',
                    '&:hover': { color: colors.red[900] },
                }}
            >
                {expanded ? 'نمایش کمتر' : 'نمایش بیشتر'}
                {expanded ? <ChevronUp size={13} /> : <ChevronDown size={13} />}
            </Box>
        </Box>
    );
}
